import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'unsuccessful-login',
  template: `<div class="msg-container">
    <h1>Your login attempt was unsuccessful</h1>
    <p>
      You do not have access to this instance of Lineup. If you believe you are receiving this
      message in error, please contact your Lineup administrator.
    </p>
  </div>`,
  styles: [
    `
      .msg-container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 70vh;
        width: 100%;
      }
    `
  ],
  standalone: false
})
export class UnsuccessfulLoginComponent implements OnInit {
  constructor(auth: AuthService, router: Router) {
    auth.error$.subscribe((err) => {
      if (!err.message.includes('Access denied')) {
        router.navigate(['/session-expired']);
      }
    });
  }

  ngOnInit() {}
}
